export const emailDomains = [
    "gmail",
    "yahoo",
    "hotmail",
    "aol",
    "msn",
    "comcast",
    "rediffmail",
    "gmx",
    "web",
    "yandex",
    "ymail",
    "libero",
    "outlook",
    "uol",
    "bol",
    "mail",
    "cox",
    "sbcglobal",
    "live",
    "googlemail",
    "ig",
    "bigpond",
    "terra",
    "neuf",
    "alice",
    "rocketmail",
    "att",
    "laposte",
    "facebook",
    "bellsouth",
    "charter",
    "rambler",
    "tiscali",
    "shaw",
    "earthlink",
    "optonline",
    "freenet",
    "t-online",
    "virgilio",
    "qq",
    "telenet",
    "me",
    "voila",
    "tin",
    "ntlworld",
    "arcor",
    "frontiernet",
    "hetnet",
    "zonnet",
    "club-internet",
    "optusnet",
    "blueyonder",
    "bluewin",
    "skynet",
    "sympatico",
    "windstream",
    "centurytel",
    "chello",
    "aim",
    "bigpond"
];